function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import Title from "segments/desktop/core-components/title/title";
import Colors from "styles/colors";
import { XS } from "constants/sizes";
import classnames from "classnames";
import { StyledVerticalTabsMobileComponent } from "./vertical-tabs-mobile-component.scss";
class VerticalTabsMobileComponent extends PureComponent {
    renderTabs() {
        const { tabs, tabsColor } = this.props;
        return tabs.map((tab, index)=>{
            const { tabLabel, textAndAsset, tabClassName, tabDisabledColor, isDisabled } = tab;
            const color = isDisabled && tabDisabledColor ? Colors[tabDisabledColor] : Colors[tabsColor];
            return /*#__PURE__*/ _jsxs("div", {
                className: classnames("tab-wrapper", {
                    [tabClassName]: tabClassName
                }),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "tab-label",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "line",
                                style: {
                                    backgroundColor: color
                                }
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text",
                                style: {
                                    color
                                },
                                children: tabLabel
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "line",
                                style: {
                                    backgroundColor: color
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "tab-content",
                        children: /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread_props(_object_spread({}, textAndAsset), {
                            titleSize: XS
                        }))
                    })
                ]
            }, index);
        });
    }
    render() {
        const { title, titleSize } = this.props;
        return /*#__PURE__*/ _jsxs(StyledVerticalTabsMobileComponent, {
            className: "vertical-tabs-mobile-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "vertical-tabs-mobile-title-wrapper",
                    children: /*#__PURE__*/ _jsx(Title, _object_spread_props(_object_spread({}, title), {
                        titleSize: titleSize
                    }))
                }),
                this.renderTabs()
            ]
        });
    }
}
export { VerticalTabsMobileComponent as default };
